import SleekTab from 'Common/Crm/SleekTab.tsx';

const DraftLogic = ({ isDraft, isEdited, setSelectTab, SelectTab, DataStatus }) => {
  const ParentTabData = [
    {
      id: 0,
      name: 'Draft',
      disabled: false,
    },
    {
      id: 1,
      name: 'Published',
      disabled: DataStatus === 1 || DataStatus === 3 ? false : true,
    },
  ];
  const handleChangeTab = (value) => {
    if (!isEdited && isDraft) {
      const userConfirmed = window.confirm('You have unsaved changes. Do you want to switch tabs?');
      if (!userConfirmed) return; // Stop if the user cancels
    }
    setSelectTab(value);
  };
  return (
    <SleekTab tabData={ParentTabData} selectedTab={SelectTab} handleChangeTab={handleChangeTab} />
  );
};

export default DraftLogic;
